import { ChangeDetectorRef, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class Service {
    public inited: boolean = false;
    private ref?: ChangeDetectorRef;

    public async init(ref?: ChangeDetectorRef) {
        if (ref) this.ref = ref;
        this.inited = true;
        return this;
    }

    public async render() {
        this.ref?.detectChanges();
    }
}

export default Service;
